export default "__VITE_ASSET__bcjYCk2g__"